var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.text)?_c('div',{staticClass:"datenschutz"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }